@if (loading) {
  <app-loading [logo]="false"></app-loading>
} @else {
  @if (backend) {
    <!-- <ng-container *ngIf="recaptcha;else robot"> -->
    <router-outlet></router-outlet>
  <!-- </ng-container>
  <ng-template #robot>
    <app-maintenance [robot]="true" (onNoRobot)="onNoRobot($event)"></app-maintenance>
  </ng-template> -->
} @else {
  <app-maintenance></app-maintenance>
}
}

